import React from 'react'

type Props = {
  status: string
}

export const StatusBadge: React.FC<Props> = ({status}) => {
  if (status.toLowerCase() === 'needs decision') {
    return (
      <span className='badge fs-7 text-dark text-bold m-1 text-capitalize' style={{background: '#F6F6F6'}}>
        {status}
      </span>
    )
  }

  const isApproved = status.toLowerCase() === 'approved'
  return (
    <span
      className={`badge fs-7 m-1 text-capitalize`}
      style={{
        color: isApproved ? '#0E9F6E' : '#EE3043',
        background: isApproved ? '#E8F8F4' : '#FFF5F8',
      }}
    >
      {status}
    </span>
  )
}
